import ModuleLocked from "pages/ModuleLocked/ModuleLocked";
import ContactPage from "../ContactPage";

const Chat = () => {
    return (
        <ContactPage translateKey={"contact-default"}>
            <ModuleLocked />
        </ContactPage>
    );
};

export default Chat;
